import { render, staticRenderFns } from "./DraftWorkouts.vue?vue&type=template&id=ca8d69da&"
import script from "./DraftWorkouts.vue?vue&type=script&lang=js&"
export * from "./DraftWorkouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports